import { homePageStyles } from "@insite/content-library/Pages/HomePage";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

homePageStyles.page = {
    fullWidth: [true, true, true, true, true],
};